// @ts-nocheck
import buttonShapes from "@insite/mobius/Button/buttonShapes";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

Object.assign(buttonShapes, {
    rounded: () => `border-radius: ${pxToRem(6)};`, // Store Custom Code
});
